<template>
  <ConfirmDialog
    class="BookingEngineErrorModal"
    icon="alert-circle"
    status="danger"
    primaryConfirm
    :modelValue="isOpen"
    :title="copy.title"
    :description="copy.body"
    :confirmLabel="copy.action"
    :cancelLabel="copy.cancel"
    @confirm="confirm"
    @cancel="close"
  />
</template>

<script setup lang="ts">
import { BOOKING_ENGINE_ERROR_I18N_PREFIX, useBookingEngineErrorModal } from '~/composables/useBookingEngineError';

const { code, confirm, close } = useBookingEngineErrorModal();

const { t } = useI18n();

const EMPTY_COPY = { title: '', body: '', action: '', cancel: '' };

/** Resolved once per active code; a closed modal has no code to build keys from. */
const copy = computed(() => {
  if (!code.value) return EMPTY_COPY;

  const prefix = `${BOOKING_ENGINE_ERROR_I18N_PREFIX}.${code.value}`;
  return {
    title: t(`${prefix}.title`),
    body: t(`${prefix}.body`),
    action: t(`${prefix}.action`),
    cancel: t(`${prefix}.cancel`),
  };
});

/** The composable owns whether the dialog is open, so the binding stays one-way and the
 *  dialog's own actions do the clearing. */
const isOpen = computed<boolean>(() => code.value !== null);
</script>
